module.exports = __webpack_public_path__ + "files/6b413d789198fd1b55706050569ac037.png";